const withoutTrailingSlash = (value: string) => value.replace(/\/+$/, '');

type PublicRuntimeConfig = Partial<Record<
  'VITE_API_BASE_URL' | 'VITE_APP_URL' | 'VITE_MARKETING_URL' | 'VITE_SUPPORT_EMAIL' | 'VITE_ANALYTICS_ID',
  string
>>;

const runtimeConfig = (): PublicRuntimeConfig => {
  if (typeof window === 'undefined') return {};
  return window.__COOPCORE_ENV__ ?? {};
};

function envValue(name: keyof PublicRuntimeConfig, buildValue: string | undefined) {
  return runtimeConfig()[name]?.trim() || buildValue?.trim() || '';
}

function requiredEnv(name: keyof PublicRuntimeConfig, value: string | undefined) {
  const resolved = envValue(name, value);
  if (!resolved) throw new Error(`${name} is required`);
  return resolved;
}

const resolvedMarketingUrl = envValue('VITE_MARKETING_URL', import.meta.env.VITE_MARKETING_URL)
  || (typeof window !== 'undefined' ? window.location.origin : '');

export const config = {
  apiBaseUrl: withoutTrailingSlash(requiredEnv('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL)),
  appUrl: withoutTrailingSlash(requiredEnv('VITE_APP_URL', import.meta.env.VITE_APP_URL)),
  marketingUrl: withoutTrailingSlash(resolvedMarketingUrl),
  supportEmail: requiredEnv('VITE_SUPPORT_EMAIL', import.meta.env.VITE_SUPPORT_EMAIL),
  analyticsId: envValue('VITE_ANALYTICS_ID', import.meta.env.VITE_ANALYTICS_ID),
};
